import { useToast } from '@chakra-ui/react';
import { useEffect, useRef } from 'react';

import {
  type DataBuilderPersistError,
  selectPersistError,
  useDataBuilderSelector,
} from './data-builder.store';

export const usePersistErrorToast = (): void => {
  const persistError = useDataBuilderSelector(selectPersistError);
  const toast = useToast();
  const lastShownRef = useRef<DataBuilderPersistError | null>(null);

  useEffect(() => {
    if (persistError === null) {
      lastShownRef.current = null;
      return;
    }
    if (lastShownRef.current === persistError) return;
    lastShownRef.current = persistError;

    toast({
      title: 'Autosave paused',
      description:
        'Your latest changes couldn’t be saved locally and will be lost on reload. You may be reaching the limits of memory in this session.',
      status: 'warning',
      duration: 10000,
      isClosable: true,
      position: 'top-right',
    });
  }, [persistError, toast]);
};
